import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=444ba3a1&scoped=true"
import script from "./Role.vue?vue&type=script&lang=ts"
export * from "./Role.vue?vue&type=script&lang=ts"
import style0 from "./Role.vue?vue&type=style&index=0&id=444ba3a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444ba3a1",
  null
  
)

export default component.exports